app.directive('countrySelect', ['$ionicModal', 'LocaleService',
    function ($ionicModal, LocaleService) {
        return {
            scope: {
                items: '<',
                config: '<',
                submit: '&onSubmit',
                close: '&onClose'
            },
            restrict: 'E',
            link: function (scope, element) {
                scope.search = {};
                var defaultConfig = {
                    label: 'value',
                    titleLabel: 'select',
                    id: 'id'
                };

                scope.config = angular.merge(defaultConfig, scope.config);

                LocaleService.wait().then(function (translation) {
                    scope.translation = translation;
                });

                $ionicModal.fromTemplateUrl('templates/directives/countrySelect.html', {
                    scope: scope,
                    hardwareBackButtonClose: false,
                    animation: 'slide-in-up'
                }).then(function (modal) {
                    scope.modal = modal;
                    scope.modal.show();
                });

                scope.setItem = function (item) {
                    scope.modal.hide();
                    scope.submit({message: item})
                };

                scope.closeModal = function () {
                    scope.modal.hide();
                    scope.close();
                }

                element.on('$destroy', function(){
                    scope.closeModal();
                })
            }
        }
    }]);
